<template>
  <header class="header" :class="winnersPage ? 'winners' : ''">
    <a class="logo-link" href="#" :title="`${siteBrand} Storytelling Competition`">
      <img class="logo" :src="siteLogo" :alt="`${siteBrand} Logo`" />
    </a>
  </header>
</template>

<style lang="scss" scoped>
.header {
  background-color: $AC_Black;
  height: 43px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1000;

  @media (min-width: 641px) {
    height: 80px;
  }

  .logo-link {
    display: block;
    line-height: 0;
  }

  .logo {
    max-width: 124px;
  }

  @media (min-width: 641px) {
    .logo {
      max-width: none;
    }
  }
}
</style>

<script setup>
import { computed } from 'vue';
import AcuraLogo from '@/assets/img/acura-logo.svg';
import HondaLogo from '@/assets/img/honda-logo.svg';

const props = defineProps({
  winnersPage: Boolean,
  siteVariant: String,
});

const siteLogo = computed(() => (props.siteVariant === 'acura' ? AcuraLogo : HondaLogo));

const siteBrand = computed(() => (props.siteVariant === 'acura' ? 'Acura' : 'Honda'));
</script>
